import { BaseDataBind } from "./base";

/**
 * Data bind for an elements individual attribute.
 */
export class AttributeDataBind extends BaseDataBind
{
    public attributeName = 'data-bind-attribute';
    public selector = '[data-bind-attribute]';
    public eventNames = [];

    protected targetAttributeName: string;

    protected getPropertyValue(element: Element)
    {
        let name = super.getPropertyValue(element);
        let parts = name.split(':');
        this.targetAttributeName = parts[0];

        return parts[1];
    }

    public setElementValue(element: Element, value: any)
    {
        element.setAttribute(this.targetAttributeName, value);
    }

    public getElementValue(element: Element)
    {
        return element.getAttribute(this.targetAttributeName);
    }
}

/**
 * Data bind for an elements individual attribute.
 */
export class SelectedDataBind extends BaseDataBind
{
    public attributeName = 'data-bind-selected';
    public selector = '[data-bind-selected]';
    public eventNames = [];

    protected targetAttributeName: string;


    public setElementValue(element: Element, value: any)
    {
        if (value === true)
        {
            element.setAttribute('selected', '');
        }
        else
        {
            element.removeAttribute('selected');
        }
    }

    public getElementValue(element: Element)
    {
        return element.hasAttribute('selected');
    }
}